// import $ from 'jquery';
import StepSelect from './module/CompareStepSelect';
// import StepResult from './module/CompareStepResult';

const { $ } = window;

export default class CompareExtent {
  constructor() {
    this.carList = null;
    this.excludetest = null;
    console.log($.address.baseURL());
    this.loadCarList();
    this.isConstructor = true;
  }

  loadCarList() {
    $.ajax({
      url: 'api/car-list.ashx',
      type: 'POST',
      dataType: 'json',
      success: (e) => {
        if (e.RS === 'OK') {
          this.carList = e.DATA || [];
          this.loadTestdriveDisabled();
        } else {
          console.log(e.RS);
        }
      },
      error: (e) => {
        console.log(e);
      },
    });
  }

  loadTestdriveDisabled() {
    $.ajax({
      url: 'api/excludetest.ashx',
      type: 'POST',
      dataType: 'json',
      success: (e) => {
        if (e.RS !== 'OK') {
          console.log(e.RS);
        } else {
          this.excludetest = e.DATA || [];
          this.onLoadCarList();
        }
      },
      error: (e) => {
        console.log(e);
      },
    });
  }

  onLoadCarList() {
    this.stepSelect = new StepSelect(this.carList, this.excludetest);
  }
}
